import React from 'react';
import { Grid, Divider, Box,
  Typography, makeStyles, Card, CardContent } from '@material-ui/core';
import { specialities } from 'pages/ManagersDoctorsPage';
import CollectionKeys from 'hooks/molecules/collection-keys';
import { useItem } from 'hooks/atoms/item-hook';
import AppLoader from 'components/basic/AppLoader';

const useStyles = makeStyles(() => {
  return {
    subtitle: {
      margin: '0px 0px 5px 5px',
      color: 'rgb(100, 141, 174)',
      fontSize: 24,
    },
    borderedTypography: {
      border: '1px solid',
      borderColor: '#8fadce',
      padding: '5px',
    },
  };
});

function FieldItem({ title, field }) {
  const classes = useStyles();

  return (
    <>
      <Typography variant='subtitle1'>
        {title}
      </Typography>
      <Typography
        className={ classes.borderedTypography }
        variant='h6'
        style={ { marginBottom: '10px', minHeight: '45px' } }
        fullWidth
      >
        {field }
      </Typography>
      <Divider />
    </>
  );
}

function ManagersDoctorsDetails({ id }) {
  const classes = useStyles();
  const {
    item: doctor,
    itemIsLoading,
    itemError,
    itemIsUpdating,
  } = useItem(CollectionKeys.DOCTORS, id);

  if (itemIsLoading || itemIsUpdating) {
    return <AppLoader />;
  }

  if (itemError) {
    return <p>Error</p>;
  }

  return (
    <Box pt={ 2 }>
      <Grid container spacing={ 3 }>
        <Grid item xs={ 12 }>
          <Typography variant='h5'>Doctor`s Details</Typography>
        </Grid>
        <Grid item xs={ 12 }>
          <Card>
            <CardContent>
              <Grid container spacing={ 3 }>
                <Grid item xs={ 12 }>
                  <Typography variant='h5' className={ classes.subtitle }>
                    Basic Info
                  </Typography>
                </Grid>
                <Grid item xs={ 6 }>
                  <FieldItem
                    title='Name'
                    field={ doctor?.name }
                  />
                </Grid>
                <Grid item xs={ 6 }>
                  <FieldItem
                    title='Family Name'
                    field={ doctor?.family_name }
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={ 12 }>
          <Card>
            <CardContent>
              <Grid container spacing={ 3 }>
                <Grid item xs={ 12 }>
                  <Typography variant='h5' className={ classes.subtitle }>
                    More Info
                  </Typography>
                </Grid>
                <Grid item xs={ 5 }>
                  <FieldItem
                    title='Specialty'
                    field={ specialities.get(doctor?.specialty) || ' ' }
                  />
                </Grid>
                <Grid item xs={ 7 }>
                  <FieldItem
                    title='Email'
                    field={ doctor?.email }
                  />
                </Grid>
                <Grid container spacing={ 3 } />
                <Grid item xs={ 6 }>
                  <FieldItem
                    title='Business Phone'
                    field={ doctor?.business_number }
                  />
                </Grid>
                <Grid item xs={ 6 }>
                  <FieldItem
                    title='Personal Phone'
                    field={ doctor?.phone_number ? doctor?.phone_number : doctor?.phoneNumber }
                  />
                </Grid>
                <Grid item xs={ 12 }>
                  <FieldItem
                    title='status'
                    field={ doctor?.verification_status }
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ManagersDoctorsDetails;
